import React from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import searchBarApis from '../../utils/searchBarApis';
import {
  Button,
  FieldDatePicker,
  FieldSelect,
  FieldSearchBar,
  CircularProgressLoader,
  AccessControl,
  PERMISSION_KEYS,
  PERMISSION_TYPES,
} from '../../components';
import ClearIcon from '@material-ui/icons/Clear';
import { FormattedMessage, injectIntl } from '../../utils/reactIntl';
import Usertype from './Usertypes.json';
import carretDown from '../../assets/svg/caretdown.svg';
import exp from '../../assets/svg/export.svg';
import '../../components/LayoutWrapperMain/LayoutWrapperMain.global.scss';

interface Props {
  handleFormSubmit: any,
  handleExport: any,
  handleResetSorts: any,
  loaderExport: any,
  intl: any,
}

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

const UserManagementFilterForm: React.FC<Props> = (props: Props) => {
  const {
    handleFormSubmit,
    intl,
    handleExport,
    handleResetSorts,
    loaderExport,
  } = props;
  const formProps = useForm();
  const [showFilter, setShowFilter] = React.useState(true);
  const [toggle, setToggle] = React.useState(false);
  const handleReset = () => {
    formProps.reset({
      search: '',
      startDate: null,
      endDate: null,
      userType: '',
    });
    handleResetSorts();
  };

  return (
    <form
      className="filterForm"
      onSubmit={formProps.handleSubmit(handleFormSubmit)}
    >
      <div className="filter_container">
        <div className="filterSearch">
          <div>
            <button type="button" className="filter" aria-expanded={showFilter}
              onClick={() => setShowFilter((prevState) => !prevState)}>
              {intl.formatMessage({ id: 'UserManagement.label.filter' })}
              <span aria-hidden="true">{showFilter ? '−' : '+'}</span>
            </button>
            <div className="fieldSet">
              <FieldSearchBar
                searchURL={searchBarApis.userManagement}
                formProps={formProps}
                name="search"
                label={intl.formatMessage({ id: 'UserManagement.label.search' })}
                id="search"
              />
            </div>
          </div>
          <AccessControl
            permissionKey={PERMISSION_KEYS.USER_MANAGEMENT}
            accessType={PERMISSION_TYPES.EDIT}
          >
            <div className="userRightExport">
              {!loaderExport
                ? (
                  <>
                    <button type="button" className="avatus-export" aria-expanded={toggle}
                      onClick={() => setToggle((prevState: boolean) => !prevState)}>
                      <img src={exp} alt="" /> Export users
                    </button>
                    {toggle && (
                      <ul className="userrigthToggle">
                        <li><button type="button"
                          onClick={() => handleExport('XLSX')}
                        >
                          {intl.formatMessage({ id: 'UserManagement.label.export.xlsx' })}
                        </button></li>
                        <li><button type="button"
                          onClick={() => handleExport('CSV')}
                        >
                          {intl.formatMessage({ id: 'UserManagement.label.export.csv' })}
                        </button></li>
                      </ul>
                    )}
                  </>
                ) : <div className="exportProgressBar"><CircularProgressLoader /></div>}
            </div>
          </AccessControl>
        </div>
        {showFilter && (
          <div>
            <p>
              {intl.formatMessage({ id: 'UserManagement.label.added' })}
            </p>
            <div className="filterOptions">
              <div className="datepickerField">
                <FieldDatePicker
                  id="startDate"
                  name="startDate"
                  label={intl.formatMessage({ id: 'UserManagement.label.startDate' })}
                  formProps={formProps}
                  maxDate={formProps.watch('endDate') !== null ? formProps.watch('endDate') : moment().subtract(0, 'years').format('YYYY-MM-DD')}
                />
              </div>
              <div className="datepickerField">
                <FieldDatePicker
                  id="endDate"
                  name="endDate"
                  label={intl.formatMessage({ id: 'UserManagement.label.endDate' })}
                  formProps={formProps}
                  minDate={formProps.watch('startDate') !== null ? formProps.watch('startDate') : moment().subtract(118, 'years').format('YYYY-MM-DD')}
                />
              </div>
              <div className="userType">
                <FieldSelect
                  menuClassName="avatus-user-type-menu"
                  id="userType"
                  name="userType"
                  variant={false}
                  label={intl.formatMessage({ id: 'UserManagement.label.userType' })}
                  formProps={formProps}
                  options={Usertype}
                />
              </div>
              <div className="buttonWrapper">
                <Button buttonType={ButtonTypes.submit} className="button">
                  <FormattedMessage id="UserManagement.label.apply" />
                </Button>
                <Button onClick={handleReset} className="button">
                  <FormattedMessage id="UserManagement.label.reset" />
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default injectIntl(UserManagementFilterForm);
